import { IconExternalLink as TablerIconExternalLink } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconExternalLink = /*#__PURE__*/ createOutlineIcon(
  TablerIconExternalLink,
  'IconExternalLink',
);
